import { useTheme } from '@material-ui/core'
import { DefinitiveDecimalTextField } from 'components/DefinitiveInputs/DefinitiveDecimalTextField'
import { EditorProps } from 'react-data-grid'
import { NumberFormatProps } from 'react-number-format'
import { useDataGridEditorNavigation } from './useDataGridEditorNavigation'

type NumberDataGridEditorProps<TRow, TSummaryRow> = {
  rootElementClassName?: string
} & EditorProps<TRow, TSummaryRow> &
  NumberFormatProps

export function NumberDataGridEditor<TRow, TSummaryRow>({
  row,
  column,
  onRowChange,
  onClose,
  rootElementClassName,
  ...rest
}: NumberDataGridEditorProps<TRow, TSummaryRow>) {
  const theme = useTheme()

  const { handleNavigationKeys } = useDataGridEditorNavigation(() => {
    onClose(true)
  })

  return (
    <DefinitiveDecimalTextField
      rootElementClassName={rootElementClassName}
      value={row[column.key]}
      onChange={(value) => {
        onRowChange({
          ...row,
          [column.key]: value,
        })
      }}
      numberFormatProps={{
        ...rest,
      }}
      textFieldProps={{
        autoFocus: true,
        onBlur: () => onClose(true),
        InputProps: {
          disableUnderline: true,
        },
        inputProps: {
          onKeyDown: handleNavigationKeys,
          onFocus: (e) => {
            e.target.select()
          },
          style: {
            textAlign: 'right',
            fontSize: theme.typography.caption.fontSize,
            paddingTop: theme.spacing(1.3),
            paddingRight: theme.spacing(1),
          },
        },
      }}
    />
  )
}
